import { GetListOperation, PostOperation } from '@/api/rest/base/operations';
import BaseApi from './base/BaseApi';

/**
 * Позиция спецификации и действия по ней (ТЗ 4.1): правка, переходы статусов, отметка
 * вознаграждения, выбор отклика и разделение скидки, отклики позиции, перезапуск агента
 * бюджета, применение подобранного фото. Сгенерировано Claude.
 */
export default class SpecItemApi extends BaseApi {
  static entityName = 'spec_items';

  /** Отклики позиции с состояниями и финансовыми полями (ТЗ 4.1). */
  fetchOffers(id, withPreloader = false) {
    const operation = new GetListOperation(`${this.getIri(id)}/offers`);
    return this.execute(operation, withPreloader);
  }

  /** Переход статуса: contract | ordered | paid | delivered | accepted (ТЗ 2.5). */
  transition(id, action, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/transition`, { action });
    return this.execute(operation, withPreloader);
  }

  /** Отметка «вознаграждение получено»: дата или null (ТЗ 4.1, 6.3). */
  rewardReceived(id, dateValue, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/reward_received`, { date: dateValue });
    return this.execute(operation, withPreloader);
  }

  /** Выбрать отклик с разделением скидки: { offer, customerDiscount } (ТЗ 4.1, 7.1). */
  chooseOffer(id, params, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/choose_offer`, params);
    return this.execute(operation, withPreloader);
  }

  /** «Вернуть в исходное состояние»: позиция снова «Есть отклики» (ТЗ 4.1, 2.5). */
  reset(id, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/reset`, {});
    return this.execute(operation, withPreloader);
  }

  /** «Заменить» позицию на аналог, предложенный AI. */
  analogApply(id, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/analog_apply`, {});
    return this.execute(operation, withPreloader);
  }

  /** «Отклонить» аналог, предложенный AI: повторно он не предлагается. */
  analogReject(id, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/analog_reject`, {});
    return this.execute(operation, withPreloader);
  }

  /** Изменить разделение скидки: { customerDiscount, reason } (ТЗ 4.1). */
  changeDiscount(id, params, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/customer_discount`, params);
    return this.execute(operation, withPreloader);
  }

  /** «Найти цену заново» — задание бюджета по одной позиции (ТЗ 4.1, 5.3). */
  findPrice(id, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/find_price`, {});
    return this.execute(operation, withPreloader);
  }
}
